import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    files = [],
    dir = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(
        URLS.common.commitFiles,
        {
            files,
            dir,
        }, options);
    if (error) return { error, status };
    return content || {};
};
